import { ReactElement } from 'react';
import compose from 'ia-react-core/~/utils/components/_compose';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow from 'ia-react-core/~/hocs/withShow';
import withFormState from '../../../hocs/form/_withFormState';

import DropdownControl, { DropdownControlProps } from './DropdownControl';
import withControl from './withControl';

export * from './DropdownControl';

const ComposedDropdownControl: (<Value, StateValue = Value, OptionValue = Value>(props: WithBehaviorsProps<DropdownControlProps<Value, StateValue, OptionValue>>) => ReactElement<WithBehaviorsProps<DropdownControlProps<Value, StateValue, OptionValue>>>) & {
  labeledControl: boolean;
} = compose<any>(
  withBehaviors,
  withShow,
  withFormState,
  withControl,
)(DropdownControl);

export default ComposedDropdownControl;
